"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureOfferCard = void 0;
var _reactI18next = require("react-i18next");
var _SubscriptionIcon = _interopRequireDefault(require("../SubscriptionIcon"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _store = require("../../redux/store");
var _formatNumber = _interopRequireDefault(require("../../util/formatNumber"));
var _planHelper = require("../../util/planHelper");
var _offerSlice = require("../../redux/offerSlice");
var _giftSlice = require("../../redux/giftSlice");
var _orderSlice = require("../../redux/orderSlice");
var _deliveryDetailsSlice = require("../../redux/deliveryDetailsSlice");
var _calculateGrossPriceForFreeOffer = _interopRequireDefault(require("../../util/calculateGrossPriceForFreeOffer"));
var _OfferCheckoutCard = _interopRequireDefault(require("./OfferCheckoutCard.utils"));
var _OfferCheckoutCardStyled = require("./OfferCheckoutCardStyled");
var _Price = _interopRequireDefault(require("../Price"));
var _jsxRuntime = require("react/jsx-runtime");
const OfferCheckoutCard = _ref => {
  let {
    isRedeemGift = false
  } = _ref;
  const {
    offerTitle: title,
    trialAvailable: isTrialAvailable,
    period,
    offerId,
    freePeriods,
    freeDays,
    expiresAt,
    startTime,
    customerPriceInclTax
  } = (0, _store.useAppSelector)(_offerSlice.selectOnlyOffer);
  const {
    loading,
    offerV2: {
      title: offerV2Title
    }
  } = (0, _store.useAppSelector)(_offerSlice.selectOffer);
  const {
    verifiedGift: {
      redeemMode,
      redeemRefusalReason
    }
  } = (0, _store.useAppSelector)(_giftSlice.selectGift);
  const {
    priceBreakdown: {
      offerPrice
    },
    taxRate,
    country,
    currency,
    totalPrice,
    discount: {
      applied: isDiscountApplied,
      type: discountType,
      periods: discountedPeriods
    }
  } = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const {
    isGift
  } = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const offerType = offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0);
  const currencySymbol = _planHelper.currencyFormat[currency];
  const isOfferFree = isTrialAvailable || isDiscountApplied && totalPrice === 0;
  const grossPrice = isOfferFree ? (0, _calculateGrossPriceForFreeOffer.default)(offerPrice, taxRate, customerPriceInclTax) : (0, _formatNumber.default)(totalPrice);
  const isTrialBadgeVisible = isTrialAvailable && discountType === 'trial';
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const taxCopy = country === 'US' ? 'Tax' : 'VAT';
  const priceValue = discountType === 'coupon' && totalPrice !== 0 ? Number(totalPrice) : Number(grossPrice);
  const periodValue = offerType === 'S' && period !== 'season' ? t("offer-price.period-".concat(period), period) : null;
  const generateTrialDescription = () => {
    if (period === 'season' && freeDays) {
      const formattedDescription = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) after {{freeDays}} days and will be renewed on the next season start date.";
      return t("subscription-desc.trial-days.period-season", formattedDescription, {
        currencySymbol,
        grossPrice,
        taxCopy,
        freeDays
      });
    }
    if (freeDays) {
      const description = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) after {{freeDays}} days. </br> Next payments will occur every ".concat((0, _OfferCheckoutCard.default)(period), ".");
      return t("subscription-desc.trial-days.period-".concat(period), description, {
        currencySymbol,
        grossPrice,
        taxCopy,
        freeDays
      });
    }

    // freePeriods
    let formattedDescription = 'You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) ';
    if (period === 'month') {
      formattedDescription += freePeriods === 1 ? 'after month. </br>Next payments will occur every month.' : 'after {{freePeriods}} months. </br>Next payments will occur every month.';
    } else if (period === 'week') {
      formattedDescription += freePeriods === 1 ? 'after week. </br>Next payments will occur every week.' : 'after {{freePeriods}} weeks. </br>Next payments will occur every week.';
    }
    return t("subscription-desc.trial-period".concat(freePeriods === 1 ? '' : 's', ".period-").concat(period), formattedDescription, {
      currencySymbol,
      grossPrice,
      taxCopy,
      freePeriods
    });
  };
  const generateCouponDescription = () => {
    const formattedTotalPrice = (0, _formatNumber.default)(totalPrice);
    const regularPrice = period === 'season' ? (0, _formatNumber.default)(customerPriceInclTax) : (0, _calculateGrossPriceForFreeOffer.default)(offerPrice, taxRate, customerPriceInclTax);
    return t("subscription-desc-coupon", "You will be charged ".concat(currencySymbol).concat(formattedTotalPrice, " (incl. ").concat(taxCopy, ") per ").concat(period, " for the promotional period.<br/>After the promotion ends, you will be charged ").concat(currencySymbol).concat(regularPrice, " per ").concat(period, "."), {
      currencySymbol,
      formattedTotalPrice,
      taxCopy,
      period,
      discountedPeriods,
      regularPrice
    });
  };
  const generateSubscriptionDescription = () => {
    if (discountType === 'coupon') {
      return generateCouponDescription();
    }
    if (isGift) {
      const description = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}).";
      return t("subscription-desc.gift", description, {
        currencySymbol,
        grossPrice,
        taxCopy
      });
    }
    if (!isTrialAvailable) {
      if (period === 'season') {
        const description = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) and will be renewed on the next season start date.";
        return t("subscription-desc.period-season", description, {
          currencySymbol,
          grossPrice,
          taxCopy
        });
      }
      const formattedDescription = "You will be charged {{currencySymbol}}{{grossPrice}} (incl. {{taxCopy}}) every ".concat((0, _OfferCheckoutCard.default)(period), ".");
      return t("subscription-desc.period-".concat(period), formattedDescription, {
        currencySymbol,
        grossPrice,
        taxCopy
      });
    }
    return generateTrialDescription();
  };
  const renderDescription = () => {
    if (offerType === 'S') {
      return generateSubscriptionDescription();
    }
    if (offerType === 'P') {
      if (!period) {
        const date = (0, _planHelper.dateFormat)(expiresAt, true);
        return t('pass-desc.date', "Access until {{date}}", {
          date
        });
      }
      return _planHelper.periodMapper[period] ? "".concat(t("period.".concat(period), _planHelper.periodMapper[period].accessText), " ").concat(t('offer-checkout-card.season-pass', 'season pass')) : '';
    }
    if (offerType === 'E') {
      return "Pay-per-view event ".concat(startTime ? (0, _planHelper.dateFormat)(startTime, true) : '');
    }
    if (offerType === 'R') {
      return _planHelper.periodMapper[period] ? "".concat(t("period.".concat(period), _planHelper.periodMapper[period].accessText), " ").concat(t('offer-checkout-card.access', 'access')) : '';
    }
    if (offerType === 'A') {
      return t('offer-checkout-card.unlimited-access', 'Unlimited access');
    }
    return '';
  };
  const renderTrialBadgeDescription = () => {
    if (freeDays) {
      return t('trial-badge-days', "{{freeDays}} days free trial", {
        freeDays
      });
    }
    if (freePeriods === 1) {
      return t("trial-badge.period-".concat(period), "1 {{period}} free trial", {
        period
      });
    }
    return t("trial-badge.periods-".concat(period), "{{freePeriods}} {{period}}s free trial", {
      freePeriods,
      period
    });
  };
  const getRedeemGiftDescription = () => {
    if (redeemMode === 'EXTEND') {
      return t("redeem-gift.description.existing-subscription.period-".concat(period), "Your existing subscription will be extended for additional ".concat((0, _OfferCheckoutCard.default)(period), " for free."));
    }
    switch (redeemRefusalReason) {
      case 'EXTERNALLY_MANAGED_SUBSCRIPTION':
        return t('redeem-gift.description.refusal.external', 'You already have an active subscription in a different store, perhaps through a mobile app. Once that subscription expires, you can come back and redeem your gift code here.');
      case 'REDEEMED':
        return t('redeem-gift.description.refusal.redeemed', 'This gift code has already been used.');
      case 'INACTIVE_OFFER':
        return t('redeem-gift.description.refusal.offer-inactive', 'Sorry, but the offer linked to your gift code is no longer available.');
      case 'OFFER_GEO_RESTRICTED':
        return t('redeem-gift.description.refusal.offer-georestricted', "Sorry, this gift code can't be used in your current location due to geographic restrictions.");
      case 'RECURRING_PROCESS_ALREADY_STARTED':
        return t('redeem-gift.description.refusal.recurring-process-started', "You’ll be able to redeem your gift code once we've finished processing a payment on your existing subscription");
      case 'MORE_THAN_ONE_MATCHING_SUBSCRIPTION':
        return t('redeem-gift.description.refusal.more-than-one-matching-subscription', 'You currently have multiple subscriptions granting you access to the content this gift provides. When one of those subscriptions expires, you can come back and redeem your gift code here.');
      case 'PUBLISHER_GEO_RESTRICTED':
        return t('redeem-gift.description.refusal.publisher-georestricted', "Sorry, this gift code can't be used in your current location due to geographic restrictions.");
      default:
        return '';
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferCheckoutCardStyled.WrapperStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
      showChildren: !loading,
      width: 50,
      height: 50,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionIcon.default, {
        period: period || offerType
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferCheckoutCardStyled.InnerWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: !loading,
        width: 200,
        margin: "0 0 10px 10px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCardStyled.TitleStyled, {
          children: t("offer-title-".concat(offerId), title || offerV2Title)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: !loading,
        width: 300,
        margin: "0 0 10px 10px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCardStyled.DescriptionStyled, {
          dangerouslySetInnerHTML: {
            __html: isRedeemGift ? getRedeemGiftDescription() : renderDescription()
          }
        })
      })]
    }), !isRedeemGift && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCardStyled.PriceWrapperStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SkeletonWrapper.default, {
        showChildren: !loading,
        width: 80,
        height: 30,
        children: [isTrialBadgeVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCardStyled.TrialBadgeStyled, {
          children: renderTrialBadgeDescription()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.default, {
          currency: _planHelper.currencyFormat[currency],
          price: priceValue,
          period: periodValue
        })]
      })
    })]
  });
};
exports.PureOfferCard = OfferCheckoutCard;
var _default = exports.default = OfferCheckoutCard;